module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.9-89.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.9.md
// module id = 505
// module chunks = 334